export default "__VITE_ASSET__C2GE13Zz__"